exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-5cd325b4]{background:#fff;padding:12px;border-radius:5px;width:300px}.card .card-header[data-v-5cd325b4]{font-size:18px}.card .card-content[data-v-5cd325b4]{font-size:14px}", ""]);

// exports
